import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponentsModule } from '../shared-components.module';
import { MatDialogRef } from '@angular/material/dialog';
import { RequestPhonePopupComponent } from '../request-phone-popup/request-phone-popup.component';

@Component({
  selector: 'app-auth-setup-success-popup',
  standalone: true,
  imports: [CommonModule, SharedComponentsModule],
  templateUrl: './auth-setup-success-popup.component.html',
  styleUrls: ['./auth-setup-success-popup.component.scss']
})
export class AuthSetupSuccessPopupComponent {
  readonly _dialog: MatDialogRef<AuthSetupSuccessPopupComponent> = inject(MatDialogRef<RequestPhonePopupComponent>);
  close() {
    this._dialog.close();
  }
}
